import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "finance-landing" }
const _hoisted_2 = { class: "finance-hero" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "hero-eyebrow" }
const _hoisted_5 = { class: "hero-top" }
const _hoisted_6 = { class: "hero-stat" }
const _hoisted_7 = { class: "tmono" }
const _hoisted_8 = {
  key: 0,
  class: "risk-row",
  "aria-label": "At-risk assets"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "dash-ticker" }
const _hoisted_11 = {
  class: "hero-search",
  role: "navigation",
  "aria-label": "Search assets"
}
const _hoisted_12 = {
  key: 0,
  class: "search-results",
  role: "listbox",
  "aria-label": "Search results"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "result-left" }
const _hoisted_15 = { class: "result-ticker" }
const _hoisted_16 = { class: "result-name" }
const _hoisted_17 = { class: "result-right" }
const _hoisted_18 = { class: "result-score" }
const _hoisted_19 = {
  key: 0,
  class: "search-empty"
}
const _hoisted_20 = {
  class: "popular-row",
  "aria-label": "Popular searches"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  class: "stress-grid",
  "aria-label": "Pinned assets"
}
const _hoisted_23 = ["aria-busy", "onClick", "onKeydown"]
const _hoisted_24 = { class: "tile-top" }
const _hoisted_25 = { class: "tile-asset" }
const _hoisted_26 = { class: "tile-ticker" }
const _hoisted_27 = { class: "tile-name" }
const _hoisted_28 = ["disabled", "title", "onClick"]
const _hoisted_29 = {
  key: 0,
  class: "tile-skel skel-score",
  "aria-hidden": "true"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "tile-bottom" }
const _hoisted_32 = {
  key: 0,
  class: "tile-skel skel-pill",
  "aria-hidden": "true"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "tile-trend" }
const _hoisted_35 = {
  key: 0,
  class: "tile-skel skel-trend",
  "aria-hidden": "true"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "hero-cta-row" }
const _hoisted_38 = {
  key: 0,
  class: "finance-breaking"
}
const _hoisted_39 = { class: "container" }
const _hoisted_40 = {
  class: "stress-grid",
  "aria-label": "Breaking assets"
}
const _hoisted_41 = ["aria-busy", "onClick", "onKeydown"]
const _hoisted_42 = { class: "tile-top" }
const _hoisted_43 = { class: "tile-asset" }
const _hoisted_44 = { class: "tile-ticker" }
const _hoisted_45 = { class: "tile-name" }
const _hoisted_46 = ["disabled", "title", "onClick"]
const _hoisted_47 = {
  key: 0,
  class: "tile-skel skel-score",
  "aria-hidden": "true"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "tile-bottom" }
const _hoisted_50 = {
  key: 0,
  class: "tile-skel skel-pill",
  "aria-hidden": "true"
}
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "tile-trend" }
const _hoisted_53 = {
  key: 0,
  class: "tile-skel skel-trend",
  "aria-hidden": "true"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { id: "subscribe" }
const _hoisted_56 = { class: "container" }
const _hoisted_57 = { class: "cta-inner" }
const _hoisted_58 = { style: {"margin-top":"16px"} }

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ASSET_CATALOG, assetLabel, assetName, POPULAR_ASSET_IDS, type AssetMeta } from '../finance/assets'

declare global {
  interface Window {
    CAT_FINANCE_API_BASE?: string
  }
}

type AssetId = string


export default /*@__PURE__*/_defineComponent({
  __name: 'FinanceLanding',
  setup(__props) {

const router = useRouter()

const stressLoading = ref(true)
const stressRows = ref<
  Array<{
    asset: AssetId
    score: number
    trend7d: number
    name: string
    label: string
    date?: string
  }>
>([])

const searchQuery = ref('')

const PINNED_ALWAYS: AssetId[] = ['SPY', 'BTC-USD']
const PINNED_RANDOM_POOL: AssetId[] = ['AAPL', 'GLD', 'NVDA', 'GOOGL', 'META', 'USO']

function pickRandomPinned(): AssetId[] {
  const pool = [...PINNED_RANDOM_POOL]
  // Fisher–Yates shuffle
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[pool[i], pool[j]] = [pool[j], pool[i]]
  }
  const picked = pool.slice(0, 2)
  return [...PINNED_ALWAYS, ...picked]
}

function initialPinnedIds(): AssetId[] {
  if (typeof window === 'undefined') return pickRandomPinned()

  try {
    const raw = window.sessionStorage.getItem('financePinnedV1')
    if (raw) {
      const parsed = JSON.parse(raw) as unknown
      if (Array.isArray(parsed) && parsed.length === 4 && parsed.includes('SPY') && parsed.includes('BTC-USD')) {
        return parsed.filter((x): x is AssetId => typeof x === 'string')
      }
    }
  } catch {
    // ignore
  }

  const ids = pickRandomPinned()
  try {
    window.sessionStorage.setItem('financePinnedV1', JSON.stringify(ids))
  } catch {
    // ignore
  }
  return ids
}

const pinnedIds = ref<AssetId[]>(initialPinnedIds())

const pinnedList = computed<AssetId[]>(() => {
  const ids = pinnedIds.value
  if (Array.isArray(ids) && ids.length === 4) return ids
  return [...PINNED_ALWAYS, ...PINNED_RANDOM_POOL.slice(0, 2)]
})

function fmtScore(score?: number) {
  if (score === undefined || score === null || Number.isNaN(score)) return '—'
  return score.toFixed(3)
}

const liveByAsset = computed(() => new Map(stressRows.value.map((r) => [r.asset, r])))

function liveScore(asset: AssetId): number | undefined {
  return liveByAsset.value.get(asset)?.score
}

function pillRegimeText(score?: number): string {
  if (score === undefined || score === null || Number.isNaN(score)) return '—'
  return scoreToRegime(score)
}

function pillRegimeClass(score?: number): string {
  if (score === undefined || score === null || Number.isNaN(score)) return 'stable'
  const r = scoreToRegime(score)
  return r === 'STRESS' ? 'stress' : r === 'TRANSITION' ? 'transition' : 'stable'
}

const searchResults = computed<AssetMeta[]>(() => {
  const q = searchQuery.value.trim().toLowerCase()
  if (!q) return []

  return ASSET_CATALOG.filter((a) => {
    const hay = `${a.id} ${a.label} ${a.name}`.toLowerCase()
    return hay.includes(q)
  }).slice(0, 10)
})

const atRiskCount = computed(() => stressRows.value.filter((r) => Number.isFinite(r.score) && r.score < 0.7).length)

const atRiskPills = computed(() => {
  const rows = [...stressRows.value]
    .filter((r) => Number.isFinite(r.score) && r.score < 0.7)
    .sort((a, b) => a.score - b.score)

  return rows.map((r) => ({
    asset: r.asset,
    label: assetLabel(r.asset),
    dotClass: r.score < 0.55 ? 'stress' : 'transition'
  }))
})

const copiedAsset = ref<AssetId | null>(null)
let copiedTimer: number | undefined

const heroDate = computed(() => {
  const d = new Date()
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
})

function apiBase(): string {
  const defaultBase = 'https://api.artrofimov.xyz'
  return (window.CAT_FINANCE_API_BASE || defaultBase).replace(/\/$/, '')
}

function scoreToRegime(score: number): 'STABLE' | 'TRANSITION' | 'STRESS' {
  if (score < 0.55) return 'STRESS'
  if (score < 0.7) return 'TRANSITION'
  return 'STABLE'
}

function toneClass(score: number): 'tone-stable' | 'tone-transition' | 'tone-stress' {
  if (score < 0.55) return 'tone-stress'
  if (score < 0.7) return 'tone-transition'
  return 'tone-stable'
}

function scoreClass(score: number): 'score-stable' | 'score-transition' | 'score-stress' {
  if (score < 0.55) return 'score-stress'
  if (score < 0.7) return 'score-transition'
  return 'score-stable'
}

function fmtTrend(v: number) {
  const sign = v >= 0 ? '+' : ''
  return `${sign}${v.toFixed(3)}`
}

function trendArrow(v: number) {
  if (Math.abs(v) < 0.005) return '→'
  return v > 0 ? '↑' : '↓'
}

function goLive(asset: AssetId) {
  void router.push({ path: '/live', query: { asset } })
}

async function copyTile(tile: { asset?: AssetId; score?: number; label?: string; date?: string; loading?: boolean }) {
  if (tile.loading || !tile.asset || tile.score === undefined) return
  const dateText = tile.date ? new Date(tile.date).toLocaleDateString() : heroDate.value
  const regime = scoreToRegime(tile.score)
  const text = `${tile.label} structural health: ${tile.score.toFixed(2)} (${regime}) — ${dateText} | finance.artrofimov.xyz`

  try {
    await navigator.clipboard.writeText(text)
    copiedAsset.value = tile.asset
    if (copiedTimer) window.clearTimeout(copiedTimer)
    copiedTimer = window.setTimeout(() => {
      copiedAsset.value = null
    }, 1500)
  } catch {
    // ignore
  }
}

function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null
}

function getString(v: unknown): string | undefined {
  return typeof v === 'string' ? v : undefined
}

function getNumber(v: unknown): number | undefined {
  if (typeof v === 'number') return v
  if (typeof v === 'string' && v.trim() !== '' && Number.isFinite(Number(v))) return Number(v)
  return undefined
}

async function fetchStressMap() {
  stressLoading.value = true
  try {
    const res = await fetch(`${apiBase()}/v1/score/live`, { cache: 'no-store' })
    if (!res.ok) throw new Error('stress map fetch failed')
    const raw = (await res.json()) as unknown
    const rowsRaw: unknown[] = Array.isArray(raw)
      ? raw
      : isRecord(raw) && Array.isArray(raw['rows'])
        ? (raw['rows'] as unknown[])
        : []

    const parsed = rowsRaw
      .map((row) => {
        if (!isRecord(row)) return null
        const asset = getString(row['asset'])
        const score = getNumber(row['score'])
        if (!asset || score === undefined) return null
        const trend7d = getNumber(row['trend_7d']) ?? 0
        const date = getString(row['date'])
        return {
          asset,
          score,
          trend7d,
          date,
          name: assetName(asset),
          label: assetLabel(asset)
        }
      })
      .filter((r): r is NonNullable<typeof r> => Boolean(r))

    stressRows.value = parsed
  } catch {
    stressRows.value = []
  } finally {
    stressLoading.value = false
  }
}

const stressTiles = computed(() => {
  const placeholders = pinnedList.value.map((id) => ({
    key: id,
    asset: id,
    label: assetLabel(id),
    name: assetName(id),
    loading: true,
    toneClass: 'tone-stable' as const,
    scoreClass: 'score-stable' as const,
    scoreText: '—',
    regimeClass: 'stable' as const,
    regimeText: '',
    trendArrow: '→',
    trendText: ''
  }))

  if (stressLoading.value || stressRows.value.length === 0) return placeholders

  const by = liveByAsset.value
  return pinnedList.value.map((id) => {
    const row = by.get(id)
    if (!row) {
      return {
        key: id,
        asset: id,
        label: assetLabel(id),
        name: assetName(id),
        loading: true,
        toneClass: 'tone-stable' as const,
        scoreClass: 'score-stable' as const,
        scoreText: '—',
        regimeClass: 'stable' as const,
        regimeText: '',
        trendArrow: '→',
        trendText: ''
      }
    }

    const regime = scoreToRegime(row.score)
    return {
      key: id,
      asset: id,
      label: assetLabel(id),
      name: assetName(id),
      date: row.date,
      loading: false,
      toneClass: toneClass(row.score),
      scoreClass: scoreClass(row.score),
      scoreText: row.score.toFixed(3),
      regimeClass: regime.toLowerCase(),
      regimeText: regime,
      trendArrow: trendArrow(row.trend7d),
      trendText: fmtTrend(row.trend7d),
      score: row.score
    }
  })
})

const pinnedTiles = stressTiles

const breakingTiles = computed(() => {
  const placeholders: Array<{
    key: string
    asset: AssetId
    label: string
    name: string
    loading: boolean
    toneClass: 'tone-stable' | 'tone-transition' | 'tone-stress'
    scoreClass: 'score-stable' | 'score-transition' | 'score-stress'
    scoreText: string
    regimeClass: 'stable' | 'transition' | 'stress'
    regimeText: string
    trendArrow: string
    trendText: string
  }> = []

  if (stressLoading.value) return placeholders
  const stressed = [...stressRows.value].filter((r) => Number.isFinite(r.score) && r.score < 0.55).sort((a, b) => a.score - b.score)
  return stressed.map((row) => {
    const regime = scoreToRegime(row.score)
    return {
      key: row.asset,
      asset: row.asset,
      label: assetLabel(row.asset),
      name: assetName(row.asset),
      date: row.date,
      loading: false,
      toneClass: toneClass(row.score),
      scoreClass: scoreClass(row.score),
      scoreText: row.score.toFixed(3),
      regimeClass: regime.toLowerCase(),
      regimeText: regime,
      trendArrow: trendArrow(row.trend7d),
      trendText: fmtTrend(row.trend7d),
      score: row.score
    }
  })
})

onMounted(async () => {
  await fetchStressMap()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, "STRUCTURAL HEALTH — " + _toDisplayString(heroDate.value) + " · Updated daily 22:00 UTC", 1),
        _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Today's structural health", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(atRiskCount.value), 1),
            _cache[1] || (_cache[1] = _createTextVNode(" assets in transition or stress today ", -1)),
            (!stressLoading.value && atRiskPills.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(atRiskPills.value, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p.asset,
                      class: "dash-pill",
                      type: "button",
                      onClick: ($event: any) => (goLive(p.asset))
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(p.label), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["dash-dot", p.dotClass])
                      }, null, 2)
                    ], 8, _hoisted_9))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              class: "asset-search",
              type: "search",
              autocomplete: "off",
              spellcheck: "false",
              placeholder: "Search assets (ticker or name)…",
              "aria-label": "Search assets"
            }, null, 512), [
              [
                _vModelText,
                searchQuery.value,
                void 0,
                { trim: true }
              ]
            ]),
            (searchQuery.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (a) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: a.id,
                      class: "search-result",
                      type: "button",
                      onClick: ($event: any) => (goLive(a.id))
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(a.label), 1),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(a.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["regime-pill", pillRegimeClass(liveScore(a.id))])
                        }, _toDisplayString(pillRegimeText(liveScore(a.id))), 3),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(fmtScore(liveScore(a.id))), 1)
                      ])
                    ], 8, _hoisted_13))
                  }), 128)),
                  (searchResults.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, "No matches."))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(POPULAR_ASSET_IDS), (id) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: id,
                  class: "pop-pill",
                  type: "button",
                  onClick: ($event: any) => (goLive(id))
                }, _toDisplayString(_unref(assetLabel)(id)), 9, _hoisted_21))
              }), 128))
            ])
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "section-h2" }, "Pinned", -1)),
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pinnedTiles), (tile) => {
            return (_openBlock(), _createElementBlock("article", {
              key: tile.key,
              class: _normalizeClass(["card stress-tile", tile.toneClass]),
              "aria-busy": tile.loading ? 'true' : 'false',
              role: "link",
              tabindex: "0",
              onClick: ($event: any) => (tile.loading ? undefined : goLive(tile.asset)),
              onKeydown: [
                _withKeys(_withModifiers(($event: any) => (tile.loading ? undefined : goLive(tile.asset)), ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(($event: any) => (tile.loading ? undefined : goLive(tile.asset)), ["prevent"]), ["space"])
              ]
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(tile.label), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(tile.name), 1)
                ]),
                _createElementVNode("button", {
                  class: "tile-share",
                  type: "button",
                  disabled: tile.loading,
                  title: copiedAsset.value === tile.asset ? 'Copied' : 'Copy share text',
                  "aria-label": "Share",
                  onClick: _withModifiers(($event: any) => (copyTile(tile)), ["stop"])
                }, " ⧉ ", 8, _hoisted_28)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["tile-score", tile.scoreClass])
              }, [
                (tile.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(tile.scoreText), 1))
              ], 2),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", {
                  class: _normalizeClass(["regime-pill", tile.regimeClass])
                }, [
                  (tile.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                    : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(tile.regimeText), 1))
                ], 2),
                _createElementVNode("div", _hoisted_34, [
                  (tile.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(tile.trendArrow) + " " + _toDisplayString(tile.trendText), 1))
                ])
              ])
            ], 42, _hoisted_23))
          }), 128))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hero-one-line" }, "Structure breaks before price. SVB: 17 days early. GLD: stress ongoing.", -1)),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_router_link, {
            class: "btn-primary hero-live-cta",
            to: "/live"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("View live scores (all assets) →", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    (breakingTiles.value.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "breaking-head" }, [
              _createElementVNode("div", { class: "label" }, "BREAKING RIGHT NOW"),
              _createElementVNode("h2", null, "What is breaking right now?"),
              _createElementVNode("div", { class: "breaking-sub" }, "Assets currently in structural stress (score below 0.55).")
            ], -1)),
            _createElementVNode("div", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breakingTiles.value, (tile) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: tile.key,
                  class: _normalizeClass(["card stress-tile", tile.toneClass]),
                  "aria-busy": tile.loading ? 'true' : 'false',
                  role: "link",
                  tabindex: "0",
                  onClick: ($event: any) => (tile.loading ? undefined : goLive(tile.asset)),
                  onKeydown: [
                    _withKeys(_withModifiers(($event: any) => (tile.loading ? undefined : goLive(tile.asset)), ["prevent"]), ["enter"]),
                    _withKeys(_withModifiers(($event: any) => (tile.loading ? undefined : goLive(tile.asset)), ["prevent"]), ["space"])
                  ]
                }, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, _toDisplayString(tile.label), 1),
                      _createElementVNode("div", _hoisted_45, _toDisplayString(tile.name), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "tile-share",
                      type: "button",
                      disabled: tile.loading,
                      title: copiedAsset.value === tile.asset ? 'Copied' : 'Copy share text',
                      "aria-label": "Share",
                      onClick: _withModifiers(($event: any) => (copyTile(tile)), ["stop"])
                    }, " ⧉ ", 8, _hoisted_46)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tile-score", tile.scoreClass])
                  }, [
                    (tile.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47))
                      : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(tile.scoreText), 1))
                  ], 2),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["regime-pill", tile.regimeClass])
                    }, [
                      (tile.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50))
                        : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(tile.regimeText), 1))
                    ], 2),
                    _createElementVNode("div", _hoisted_52, [
                      (tile.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53))
                        : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(tile.trendArrow) + " " + _toDisplayString(tile.trendText), 1))
                    ])
                  ])
                ], 42, _hoisted_41))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[11] || (_cache[11] = _createStaticVNode("<section class=\"signal\" data-v-e21a52c2><div class=\"container\" data-v-e21a52c2><div class=\"signal-inner\" data-v-e21a52c2><div class=\"signal-title\" data-v-e21a52c2>Structure breaks before price.</div><div class=\"signal-sub\" data-v-e21a52c2> Structural health measures internal coherence — how an asset behaves relative to the relationships that normally support it. When coherence degrades, fragility is building before any chart pattern shows it. Mandelbrot proved markets are fractal and turbulent. We measure the coherence of those fractal systems daily. </div></div></div></section><section class=\"case-studies\" data-v-e21a52c2><div class=\"container\" data-v-e21a52c2><div class=\"case-grid\" data-v-e21a52c2><article class=\"card case-card border-transition\" data-v-e21a52c2><div class=\"case-label\" data-v-e21a52c2>LIVE · UPDATED DAILY</div><div class=\"case-head\" data-v-e21a52c2>Live example: structural stress can lead price</div><div class=\"case-body\" data-v-e21a52c2> Live structural health updates daily across assets. Use the live view to inspect current stress, regime duration, and recent history — then compare with price action and the prevailing narrative. </div><div class=\"case-stat\" data-v-e21a52c2><div class=\"case-stat-num\" data-v-e21a52c2>Open Live →</div><div class=\"case-stat-label\" data-v-e21a52c2>see all assets</div></div></article><article class=\"card case-card border-transition\" data-v-e21a52c2><div class=\"case-label\" data-v-e21a52c2>FINANCE · BANKING · 2023</div><div class=\"case-head\" data-v-e21a52c2>17 days of structural warning before Silicon Valley Bank collapsed</div><div class=\"case-body\" data-v-e21a52c2> The structural health signal for the banking sector began declining February 21, 2023 — while SIVB stock traded at ~$273 and no public warning existed. FDIC seized the bank March 10, 2023. </div><div class=\"case-stat\" data-v-e21a52c2><div class=\"case-stat-num\" data-v-e21a52c2>17 days</div><div class=\"case-stat-label\" data-v-e21a52c2>signal to collapse</div></div></article><article class=\"card case-card border-navy\" data-v-e21a52c2><div class=\"case-label\" data-v-e21a52c2>FINANCE · SYSTEMIC · 2008</div><div class=\"case-head\" data-v-e21a52c2>49 days before the crisis</div><div class=\"case-body\" data-v-e21a52c2> Cross-asset structural coherence began degrading 49 days before Lehman Brothers collapsed. The relationship breakdown was visible in coherence metrics long before individual price charts showed the pattern. </div><div class=\"case-stat\" data-v-e21a52c2><div class=\"case-stat-num\" data-v-e21a52c2>49 days</div><div class=\"case-stat-label\" data-v-e21a52c2>lead time before Lehman</div></div></article><article class=\"card case-card border-navy\" data-v-e21a52c2><div class=\"case-label\" data-v-e21a52c2>EXTERNAL SHOCK · 2020</div><div class=\"case-head\" data-v-e21a52c2>The system stayed silent before COVID — correctly</div><div class=\"case-body\" data-v-e21a52c2> The 2020 crash was an external shock with no prior structural buildup. The engine produced no pre-failure signal — which was the correct output. This validates the difference between structural fragility (detectable) and exogenous shocks (not detectable in advance). </div><div class=\"case-stat\" data-v-e21a52c2><div class=\"case-stat-num\" data-v-e21a52c2>0 false signals</div><div class=\"case-stat-label\" data-v-e21a52c2>correct silence</div></div></article></div><div class=\"case-foot\" data-v-e21a52c2> Validated on 18 years of SPY data. Not financial advice. </div></div></section><section class=\"how\" data-v-e21a52c2><div class=\"container\" data-v-e21a52c2><div class=\"cols3\" data-v-e21a52c2><div class=\"step\" data-v-e21a52c2><div class=\"step-num\" data-v-e21a52c2>01</div><div class=\"step-title\" data-v-e21a52c2>Structural coherence</div><div class=\"step-text\" data-v-e21a52c2> Measures cross-asset relationships daily. Not price. Not volatility. The compatibility between an asset and the forces that normally support it — the same approach that detected degradation in German power grids 23 hours before voltage monitoring fired. </div></div><div class=\"step\" data-v-e21a52c2><div class=\"step-num\" data-v-e21a52c2>02</div><div class=\"step-title\" data-v-e21a52c2>Divergence window</div><div class=\"step-text\" data-v-e21a52c2> When structure and price move in opposite directions, one must correct. Structure moves first. The divergence window is the signal. </div></div><div class=\"step\" data-v-e21a52c2><div class=\"step-num\" data-v-e21a52c2>03</div><div class=\"step-title\" data-v-e21a52c2>Plain signal</div><div class=\"step-text\" data-v-e21a52c2> A score (0–1), a regime (stable / transition / stress), and one sentence. No jargon. No noise. The window, clearly marked. </div></div></div></div></section><section class=\"limit\" data-v-e21a52c2><div class=\"container\" data-v-e21a52c2><div class=\"card limit-card\" data-v-e21a52c2><div class=\"label\" style=\"margin-bottom:12px;\" data-v-e21a52c2>WHAT THIS DOESN&#39;T DO</div><p class=\"limit-text\" data-v-e21a52c2> The 2020 COVID crash produced no early structural signal. That was correct — COVID was an external shock with no prior internal degradation to detect. This system measures endogenous coherence loss, not sudden exogenous events. <br data-v-e21a52c2><br data-v-e21a52c2> Mandelbrot showed markets are fractal — turbulence clusters, tails are fat, and rare events are far more common than Gaussian models predict. Classical risk tools assume smoothness. This system monitors coherence in fractal systems. It will stay silent when silence is correct. </p></div></div></section>", 4)),
    _createElementVNode("section", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Waitlist opens soon", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("p", null, " We’re expanding the asset catalog, improving search/navigation, and adding longer history. The public waitlist will open soon. ", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("p", { style: {"margin-top":"12px"} }, " For now, use the live view to explore the current stress map and asset history. ", -1)),
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_router_link, {
              class: "btn-primary",
              to: "/live"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("View live scores →", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})